export default
    {
        path: "/financeReport",
        component: () => import('../view/discovery/financeReport/financeReport.vue'),
        children: [
            {
                path: "",
                name: '',
                component: () => import('../view/discovery/financeReport/finance.vue'),
                props: (route) => (
                    {
                        token: route.query.token,
                        deviceType: route.query.deviceType,
                        userId: route.query.userId,
                        secondLoginType: route.query.secondLoginType,
                        secondAssessToken: route.query.secondAssessToken,
                        deviceId: route.query.deviceId,
                    }
                ),
            },
            
        ]

    }



// WEBPACK FOOTER //
// ./src/router/financeRouter.js